const ChevronDownIcon = ({ className = "w-6 h-6", ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.73467 9C5.96199 9 5.57503 9.93417 6.1214 10.4806L11.3868 15.746C11.7255 16.0847 12.2746 16.0847 12.6133 15.746L17.8788 10.4806C18.4251 9.93417 18.0382 9 17.2655 9H6.73467Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronDownIcon;
